import React from 'react';
import api from "../../../general/js/api";
import eventBus from '../../../general/js/event-bus';
import PropTypes from 'prop-types';
import {EVENT_AUTH_TRIGGER_CLICK} from "../../../general/js/app";

const EVENT_ON_CHANGE_SAVED_STATUS = 'lots:onSavedButtonChange';

export default class LotFavoritesButton extends React.PureComponent {

    constructor(props) {
        super(props);

        this.isInitiator = false;
        this.state = {
            button: this.props.button,
            isLoading: false
        };

        this.onButtonClick = this.onButtonClick.bind(this);
    }

    componentDidMount() {
        this.lotSaveButtonChangeEventName = this.getLotSaveButtonChangeEventName();
        if (this.lotSaveButtonChangeEventName) {
            this.subscription = eventBus.addListener(this.lotSaveButtonChangeEventName, this.onChangeSaveButton.bind(this));
        }
    }

    onChangeSaveButton(saveButton) {
        if (this.isInitiator) {
            this.isInitiator = false;
        } else {
            this.applySaveButton(saveButton);
        }
    }

    getLotSaveButtonChangeEventName() {
        if (this.state.button) {
            return `${EVENT_ON_CHANGE_SAVED_STATUS}:${this.state.button.lotId}`
        } else {
            return null;
        }
    }

    componentWillReceiveProps(nextProps) {
        this.applySaveButton(nextProps.button);
    }

    componentWillUnmount() {
        if (this.subscription) {
            this.subscription.remove();
        }
    }

    onButtonClick(e) {
        e.preventDefault();
        if (this.state.button.triggerLogin) {
            eventBus.emit(EVENT_AUTH_TRIGGER_CLICK);
        } else {
            this.setState({isLoading: true}, () => {
                this.toggle();
            })
        }
    }

    applySaveButton(saveButton) {
        this.setState({button: saveButton});
    }

    toggle() {
        api.post(this.state.button.action).then(({ data: { saveButton } }) => {
            this.applySaveButton(saveButton);

            this.isInitiator = true;
            if (this.lotSaveButtonChangeEventName) {
                eventBus.emit(this.lotSaveButtonChangeEventName, saveButton);
            }
        }, (error) => {
            return Promise.reject(error);
        }).finally(() => {
            this.setState({
                isLoading: false
            });
        });
    }

    render() {
        let button = this.state.button;
        if (button) {
            let {isSaved, text} = button;
            let mobileSticky = this.props.mobileSticky;
            return (
                <button type="button"
                        className={`btn favorites-button ${isSaved ? 'is-saved' : '' } ${mobileSticky ? 'favorites-button--mobile-sticky' : '' }`}
                        onClick={this.onButtonClick}>
                    <span className="btn__wrap">
                         <svg width="15" height="15" className="icon icon--before">
                            <use xlinkHref="#icon-star"></use>
                        </svg>
                        <span className="favorites-button__text">
                            {text}
                        </span>
                        <div
                            className={`spinner spinner--inner spinner--faded ${this.state.isLoading ? 'is-loading' : '' }`}>
                        </div>
                    </span>
                </button>
            );
        }

        return null;
    }
}

LotFavoritesButton.defaultProps = {
    mobileSticky: false
};

LotFavoritesButton.propTypes = {
    button: PropTypes.object,
    mobileSticky: PropTypes.bool,
};




// WEBPACK FOOTER //
// ./app/components/favorites-button/js/LotFavoritesButton.js